import session from '@api/session'
import { APIEndpoint } from '@api/_version'

export default {
  voidCancellation(payload) {
    return session.post(APIEndpoint + '/api/subscription/renew/')
  },
  generateCheckoutSession(payload) {
    return session.post(APIEndpoint + '/api/subscription/checkout/', payload)
  },
  generateCustomerPortalSession(payload) {
    return session.post(APIEndpoint + '/api/subscription/customer-portal/', payload)
  },
}
